export default __webpack_public_path__ + "static/media/flag-spain-inactive.04f7c63b.svg";